export const helpers = {
    mountStripeElement(id = "stripe-card") {
        card = elements.create("card", {
            iconStyle: "solid",
            style: {
                base: {
                    fontWeight: 400,
                    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
                    fontSize: "16px",
                    fontSmoothing: "antialiased",

                    "::placeholder": {
                        color: "#787878",
                    },
                    ":-webkit-autofill": {
                        color: "#fce883",
                    },
                },
                invalid: {
                    iconColor: "#fb5253",
                    color: "#fb5253",
                },
            },
        });
        card.mount(`#${id}`);
    },

    toggleVisibleByClass(className) {
        [].forEach.call(document.getElementsByClassName(className), e =>
            e.classList.toggle("d-none")
        );
    },

    toggleSpinner(id, text = "Processing...") {
        const target = document.getElementById(id);
        const spinner = document.getElementById(`spinner-${id}`);
        if (target) {
            if (spinner) {
                const hidden = document.getElementById(`contents-${id}`);
                spinner.parentNode.removeChild(spinner);
                target.innerHTML = hidden.innerHTML;
                if (spinner.parentNode) spinner.parentNode.removeChild(hidden);
            } else {
                const i = document.createElement("i");
                i.setAttribute("id", `spinner-${id}`);
                i.classList.add("fa", "fa-spin", "fa-circle-o-notch", "mr-2");
                const hidden = document.createElement("template");
                hidden.setAttribute("style", "display:none");
                hidden.setAttribute("id", `contents-${id}`);
                hidden.innerHTML = target.innerHTML;
                target.innerHTML = text;
                target.prepend(i);
                target.append(hidden);
            }
        }
    },

    isSpinnerActive(id) {
        const target = document.getElementById(id);
        const spinner = document.getElementById(`spinner-${id}`);
        return !!target && !!spinner;
    },

    goLink(url) {
        window.location.href = url;
    },

    getRequestParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    },

    cleanEmptyProperties(payload) {
        Object.keys(payload).forEach(k => {
            if (!(payload[k] === 0) && !payload[k]) {
                delete payload[k];
            }
        });
        return payload;
    },

    _get(obj, path, def) {
        //Exposes Lodash's method to the template
        return window._.get(obj, path, def);
    },

    formatPhone(phone) {
        if (phone) {
            phone = phone.replace(/\D/g, "");
            let parsedPhone = `(${phone.substr(0, 3)}) ${phone.substr(3, 3)}-${phone.substr(6, 4)}`;
            if (phone.length > 10) {
                parsedPhone += ` x${phone.substr(10)}`;
            }
            return parsedPhone;
        }
    },

    forceUpper(e, o, prop, vue) {
        const start = e.target.selectionStart;
        e.target.value = e.target.value.toUpperCase();
        vue.$set(o, prop, e.target.value);
        e.target.setSelectionRange(start, start);
    },

    prepareCodesPayload(payload) {
        ["cpt_codes", "service_codes", "diagnoses"].forEach(prop => {
            if (payload.hasOwnProperty(prop) && payload[prop] && payload[prop].length) {
                payload[prop].forEach((payloadProp, index) => {
                    if (typeof payloadProp === "string") {
                        //If we already got an array of strings (the code), do nothing
                        return;
                    }
                    if (payloadProp.hasOwnProperty("code") && payloadProp["code"]) {
                        //Otherwise make the array item be the code
                        payload[prop][index] = payloadProp["code"];
                    }
                });
            }
        });
        return payload;
    },

    formatMoney(amount) {
        if (!isNaN(amount) && (amount || parseFloat(amount) === 0)) {
            return `$${parseFloat(amount).toFixed(2)}`;
        }
        return `$0.00`;
    },

    printElement(id) {
        let elem = document.getElementById(id);
        let domClone = elem.cloneNode(true);

        let printSection = document.getElementById("printSection");
        if (!printSection) {
            printSection = document.createElement("div");
            printSection.id = "printSection";
            document.body.appendChild(printSection);
        }
        printSection.innerHTML = "";

        printSection.appendChild(domClone);

        window.print();
    },

    secondsToMinutes(seconds) {
        return `${Math.floor(seconds / 60)}:${("0" + (seconds % 60)).slice(-2)}`;
    },

    truncateText(text, charLimit, append = "") {
        let textArray = text.split("");
        let truncatedArray = textArray.slice(0, charLimit);
        return truncatedArray.join("") + append;
    },

    zeroPad(num, zeroes = 1) {
        return ("0".repeat(zeroes) + num).slice((zeroes + 1) * -1);
    },
};
